import { BlankEditorResult } from '@doltech/ui/lib/figma/BlankEditor/Result/BlankEditorResult';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestCompletionNoHintQuestionInstance } from '../../../student-do-test/model/Question/do-test-completion-no-hint-question.store';

export interface ViewTestCompletionNoHintProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestCompletionNoHintQuestionInstance;
  isPdfContent: boolean;
}

export const Main = styled(Box)`
  font-size: 16px;
  padding: 16px;
  @media ${deviceBreakpoints.fromTablet} {
    padding: 24px;
  }
`;

export const Heading = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;

  @media ${deviceBreakpoints.fromTablet} {
    text-align: center;
  }
`;

export const ParagraphWrapper = styled.div`
  background-color: ${colorsV2.gray10};
  width: 100%;
  padding: 16px;
  border-radius: 8px;

  .paragraph-container {
    margin-top: -8px;
    margin-bottom: -8px;
  }
`;

export const ViewTestCompletionNoHint = observer((props: ViewTestCompletionNoHintProps) => {
  const { data, isPdfContent, ...rest } = props;
  const { no, heading, paragraph } = data;
  const editorValueJs = JSON.parse(paragraph.editorValue);

  return (
    <Main className="dol-question" {...rest}>
      <Heading>{heading}</Heading>
      <ParagraphWrapper>
        <BlankEditorResult
          value={editorValueJs}
          currentSelectedIndex={no}
          testMode={TestModeEnum.VIEW_TEST_QUESTION}
          blanks={paragraph.blanks.map((blank) => {
            return {
              ...blank,
              no: blank.no + no + blank.key,
            };
          })}
        />
      </ParagraphWrapper>
    </Main>
  );
});
